<template>
  <div class="formGroup" :data-layout="layout">

    <input type="hidden" :v-if="storagePath" name="storage_path" :value="storagePath">

    <div class="palmLoading" v-show="isLoading">
      <div class="palmLoading__content">
        <app-loading class="palmLoading__indicator" :is-loading="true"></app-loading>
        <p class="palmLoading__message">写真の<br>アップロード中</p>
      </div>
    </div>

    <div class="formGroup__body">
      <input type="text" style="display: none" v-for="field in fields" :key="field.name"
        v-if="field.sendFlg"
        v-validate="{ rules: { required: true } }"
        :name="field.name" :value="values[field.name]"
      >

      <formLabel :label="label"></formLabel>
      <div class="palmSideLabels">
        <div class="palmSideLabels__item" v-show="hasSendFlgs('left')">左手</div>
        <div class="palmSideLabels__item" v-show="hasSendFlgs('right')">右手</div>
      </div>
      <div class="palmInputGroup">
        <div class="palmInputGroup__item palmInput"
          v-for="field in fields"
          v-show="field.sendFlg"
          :data-uploaded="Boolean(values[field.name])">
          <div class="palmInput__target">
            <img class="palmInput__preview" :src="getImagePath(values[field.name])"
              @click="showModal(field)">
            <label class="palmInput__input">
              <input type="file" @change="handleTmpUpload($event, field.name)">
            </label>
          </div>
          <p class="palmInput__label">{{ field.shortLabel }}</p>
        </div>
      </div>
    </div>
    <div class="formGroup__footer">
      <slot></slot>
      <p class="formGroup__errorMessage"
        v-for="(field, index) in fields" :key="field.name"
        v-if="field.sendFlg && errors.has(field.name)"
      >{{ `${field.label}は入力必須です` }}</p>
    </div>

    <div class="caution">
      <h4>手相写真を撮る時のポイント</h4>
      <p>必ず、<strong>正面から、手のシワにピントを合わせて</strong>撮ってください</p>
      <div class="palmSample">
        <div class="palmSample__row">
          <h5>⭕良い例</h5>
          <div class="palmSample__image">
            <img src="/static/img/palm-sample1.jpg" data-title="⭕良い例" @click="showSample($event)">
            <img src="/static/img/palm-sample2.jpg" data-title="⭕良い例" @click="showSample($event)">
          </div>
        </div>
        <div class="palmSample__row">
          <h5>❌悪い例</h5>
          <div class="palmSample__image" data-type="NG">
            <img src="/static/img/palm-sample3.jpg" data-title="❌悪い例" @click="showSample($event)">
            <img src="/static/img/palm-sample4.jpg" data-title="❌悪い例" @click="showSample($event)">
          </div>
        </div>
      </div>
      <ul>
        <li>影が写り込む場合は、白い壁や紙に手の甲をつけてみましょう</li>
        <li>指先の力を抜き、少し手を丸めると細かいシワまでしっかり写ります<br>(指を開きすぎると、手のシワが消えてしまいます)</li>
        <li>全体写真は、指先から手首のシワまでを撮ってください</li>
        <li>可能なら、誰かに撮ってもらった方が簡単に撮れます</li>
      </ul>
    </div>

    <app-dialog :active="modalVisibility" :title="modalData.title" @close="modalVisibility = false">
      <template slot="content">
        <img :src="modalData.imagePath" style="width: 100%;">
      </template>
      <template slot="footer" class="content" v-if="modalData.showFooter">
        <button class="btn" data-color="danger" @click="handleDelete(modalData)">
          <i class="material-icons">delete</i>手相を削除する
        </button>
      </template>
    </app-dialog>
  </div>
</template>

<script>
import UploadImageByBlob from '@/utils/UploadImageByBlob'
import mixin from './mixin'
import { FORM_LABELS } from '@/CONSTS'

export default {
  name: "form-palm-input",
  mixins: [mixin],
  data: () => ({
    isLoading: false,
    placeholderImage: "/static/img/palm-placeholder.svg",
    modalVisibility: false,
    modalData: {},
    uploadErrorMessage: '',
  }),
  props: {
    inputParam: Object,
    fields: Array,
    storagePath: String,
    values: Object, Array
  },
  created() {
    // $input_paramから表示フラグの切替
    // $postParamsから入力済みパラメータを再設定
  },
  methods: {
    /**
     * $storage_pathと結合した一時アップロード画像パスを返却
     * fileNameが指定されていない場合デフォルト画像を表示
     */
    getImagePath(fileName = '') {
      if (fileName) {
        return this.storagePath + fileName
      } else {
        return this.placeholderImage
      }
    },
    handleTmpUpload($evt, key) {
      this.isLoading = true
      const file = $evt.target.files[0]
      const fileUpload = new UploadImageByBlob(file)
      fileUpload.upload()
        .then(res => {
          if (res.data.response === 'OK') {
            this.uploadErrorMessage = ''
            Object.assign(this.values, {
              [key]: res.data.file
            })
          }
        })
        .catch(error => {
          this.uploadErrorMessage = error
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showModal(data) {
      this.modalVisibility = true
      Object.assign(data, {
        title: '手相の確認',
        showFooter: true,
        imagePath: this.getImagePath(this.values[data.name])
      })
      this.$set(this, 'modalData', data);
    },
    showSample($event) {
      this.modalData = {
        imagePath: $event.target.src,
        title: $event.target.dataset.title,
        showFooter: false
      }
      this.modalVisibility = true
    },
    handleDelete(data) {
      let confirm = window.confirm(
        `${data.label}の写真を削除します。よろしいですか？`
      );
      if (confirm) {
        this.modalVisibility = false;
        this.modalData = {}
        // valueを空にする
        this.values[data.name] = ''
      }
    },
    /**
     * ラベル部分表示判定用
     * @param {String} side - 'right' or 'left'
     * @return Boolean
     */
    hasSendFlgs(side) {
      if (!(side === 'right' || side === 'left')) {
        return true
      }
      return this.fields
        .filter(field => field.name.includes(side) && field.sendFlg)
        .length > 0
    }
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/forms/FormPalmInput.vue